// Static country list for the targeting Countries field (no Zernio /countries
// endpoint — it's a small fixed set; B2b.7 geo search is cities/regions only).
// Common Snap markets first, then a broader set. ISO-3166-1 alpha-2.
export const COMMON_COUNTRIES: Array<{ code: string; name: string }> = [
  { code: 'AU', name: 'Australia' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'US', name: 'United States' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'CA', name: 'Canada' },
  { code: 'IE', name: 'Ireland' },
  { code: 'SG', name: 'Singapore' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'IN', name: 'India' },
  { code: 'PH', name: 'Philippines' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'AE', name: 'United Arab Emirates' },
];

export function countryName(code: string): string {
  return COMMON_COUNTRIES.find((c) => c.code === code)?.name ?? code;
}

// Derive a default country (ISO-2) from the ad account's IANA timezone (the only
// locale signal listAdAccounts surfaces). Small mapping of the common markets;
// returns null when there's no confident match (→ AM picks from scratch).
const TZ_PREFIX_TO_COUNTRY: Array<[RegExp, string]> = [
  [/^Australia\//, 'AU'],
  [/^Pacific\/Auckland|^Pacific\/Chatham/, 'NZ'],
  [/^America\//, 'US'], // also CA, but US is the dominant Meta-ads case
  [/^Europe\/London|^Europe\/Belfast/, 'GB'],
  [/^Europe\/Dublin/, 'IE'],
  [/^Asia\/Singapore/, 'SG'],
  [/^Africa\/Johannesburg/, 'ZA'],
  [/^Asia\/Kolkata|^Asia\/Calcutta/, 'IN'],
  [/^Asia\/Manila/, 'PH'],
  [/^Europe\/Berlin/, 'DE'],
  [/^Europe\/Paris/, 'FR'],
  [/^Europe\/Amsterdam/, 'NL'],
  [/^Asia\/Dubai/, 'AE'],
];

export function deriveDefaultCountry(timezoneName: string | null): string | null {
  if (!timezoneName) return null;
  for (const [re, code] of TZ_PREFIX_TO_COUNTRY) {
    if (re.test(timezoneName)) return code;
  }
  return null;
}

// Map the ad-account currency (the structured, reliable locale signal — far better
// than the timezone proxy that mis-scopes NZ clients billed to AU) → ISO-2 country.
// Used to BIAS the unified geo search toward the account's likely country (NOT to
// filter — the search is global so NZ + all countries appear). Null for unmapped.
const CURRENCY_TO_COUNTRY: Record<string, string> = { AUD: 'AU', NZD: 'NZ', USD: 'US', GBP: 'GB', SGD: 'SG' };
export function currencyToCountry(currency: string | null): string | null {
  return currency ? (CURRENCY_TO_COUNTRY[currency] ?? null) : null;
}
